﻿import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
    static get values() {
        return {
            addUrl: String,
            removeUrl: String
        }
    }

    static get targets() {
        return ["add", "remove"];
    }

    async add(e) {
        e.preventDefault();
        await fetch(this.addUrlValue, { method: "post" });
        this.addTarget.classList.remove("js-favourite-current");
        this.removeTarget.classList.add("js-favourite-current");
    }

    async remove(e) {
        e.preventDefault();
        await fetch(this.removeUrlValue, { method: "post" });
        this.addTarget.classList.add("js-favourite-current");
        this.removeTarget.classList.remove("js-favourite-current");
    }
}